import React, { useState, useEffect } from 'react';

export default function FloatingMessage({ message }) {
    return (
        <div className="position-absolute">
            <div className="floating-message text-center mt-2 position-relative" style={{top: -30}}>
                {message}
            </div>
        </div>
    );
}